window.dataLayer = window.dataLayer || [];

export const dataLayerFormAction = (dataLayerFormName, action, message = true, fieldValue) => {
    if (!message && !fieldValue) {
        // Form submitted
        window.dataLayer.push({
            event: `custom.form.${action}`,
            form: dataLayerFormName,
            action
        });
    } else if (fieldValue && !message) {
        // Complete field
        window.dataLayer.push({
            event: `custom.form.${action}`,
            form: dataLayerFormName,
            action: 'field complete',
            field: fieldValue.field,
            value: fieldValue.value
        });
    } else {
        // Form error
        window.dataLayer.push({
            event: `custom.form.${action}`,
            form: dataLayerFormName,
            action,
            message
        });
    }
};

export const dataLayerFreetext = (dataLayerFormName, field) => {
    window.dataLayer.push({
        event: 'custom.form.field',
        form: dataLayerFormName,
        field
    });
};

export const dataLayerSearch = (searchTerm, hits) => {
    window.dataLayer.push({
        event: 'custom.search.start',
        searchterm: searchTerm,
        numResults: hits
    });
};

export const dataLayerResultClicked = (searchTerm, hits, title, position) => {
    window.dataLayer.push({
        event: 'custom.search.result.clicked',
        searchterm: searchTerm,
        numResults: hits,
        result: title,
        position
    });
};

export default {
    dataLayerFormAction,
    dataLayerSearch,
    dataLayerResultClicked,
    dataLayerFreetext
};
